import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/companies/list', data, {params})
  },
  listAll() {
    return http.get('/companies')
  },
  listActive() {
    return http.get('/companies', {params: {status: 1}})
  },
  changeStatus(id, status) {
    return http.put(`/companies/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/companies', data)
  },
  update(id, data) {
    return http.put(`/companies/${id}`, data)
  },
  saveDeliveryChannels(id, channels) {
    return http.put(`/companies/${id}/delivery-channels`, channels)
  },
  // Lista vacía = la empresa declaró que no tiene dominio propio.
  saveEmailDomains(id, domains) {
    return http.put(`/companies/${id}/email-domains`, domains)
  },
  get(id) {
    return http.get(`/companies/${id}`)
  },
  queryDni(dni) {
    return http.get(`/companies/dni/${dni}`)
  },
  download(data) {
    return http.post("/companies/xlsx", data, { responseType: "blob" });
  },
  queryRuc(ruc) {
    return http.get(`/companies/ruc/${ruc}`)
  },
  saveConfig(id, formData) {
    return http.put(`/companies/${id}/config`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  getConfigImage(id, type) {
    return http.get(`/companies/${id}/config/image/${type}`, { responseType: 'blob' })
  }
}
